import Home from '../views/Home.vue'
import Order from '../views/Order.vue'

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/order/:orderId',
    name: 'Order',
    component: Order
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js